// extracted by mini-css-extract-plugin
export default {"AuthErrorsContainer":"AuthErrorsContainer---M_RuR"};